export enum ORGANIZATION_ROLES_ACTIONS {
  ADD_ROLE = 'add_role',
  DELETE_ROLE = 'delete_role',
  EDIT_ROLE = 'edit_role',
  VIEW_CREDENTIALS = 'view_credentials',
}

export const ORGANIZATION_ROLES_ACTION_TITLES = {
  [ORGANIZATION_ROLES_ACTIONS.ADD_ROLE]: 'Add ROLE',
};

export enum ORGANIZATION_ROLES_MESSAGE {
  REQUIRED_FIELD = 'Please fill out all fields',
  ROLE_ALREADY_EXIST = 'That role already exists in your organization. Please enter a different name.',
  ROLE_IS_ASSIGNED = 'This role is currently assigned to one or more users in your organization. Please assign them to a different role first.',
}

export enum ORGANIZATION_ROLES_STATUS {
  ACTIVE = 1,
  INACTIVE = 2,
}

export interface OrganizationRoleRow {
  organizationRoleId?: number;
  name: string;
}

export interface OrganizationRoleUpdatePayload extends OrganizationRoleRow {
  statusId?: ORGANIZATION_ROLES_STATUS;
}

export class OrganizationRoleCredentialPresentation {
  acronym: string;
  name: string;
  countryName: string;
  stateName: string;
  requiredForOnboarding: boolean;
}

export class OrganizationRoleCredentialsPresentation {
  credentials: OrganizationRoleCredentialPresentation[];
}
